<!--我的优惠券第2版-->
<!-- coupon-list 失效样式 -->
<template>
  <div class="main-gray-back">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="row-list"
          v-for="(item, index) in list"
          :key="index"
          @click="onItemChange(item, index)"
        >
          <div
            class="sale-box"
            :style="check_index == index ? 'border:1px solid #ccc' : ''"
          >
            <div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">购买人:</span>
                <span class="" style="margin-left: 0.1rem">{{
                  item.user_name
                }}</span>
              </div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">收件人:</span>
                <span class="" style="margin-left: 0.1rem">{{
                  item.express_user_name
                }}</span>
              </div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">手机号:</span>
                <span class="" style="margin-left: 0.1rem">{{
                  item.express_user_phone
                }}</span>
              </div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">收获地址:</span>
                <span class="" style="margin-left: 0.1rem">{{
                  item.express_address
                }}</span>
              </div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">订单状态:</span>
                <span class="" style="margin-left: 0.1rem">{{
                  item.order_status.name
                }}</span>
              </div>
              <div
                class="flex-start goods_item_b"
                v-for="(order, o) in item.items"
                :key="o"
              >
                <img
                  style="
                    width: 1.5rem;
                    height: 1.5rem;
                    min-width: 1.5rem;
                    margin-right: 0.2rem;
                  "
                  :src="order.pic_url"
                  alt=""
                  srcset=""
                />
                <div style="height: 1.5rem; flex: 1">
                  <div class="show-two-row">{{ order.title }}</div>
                  <div class="show-two-row" style="color: red">
                    {{ order.goods_price }}
                  </div>
                  <div class="flex-between">
                    <div class="show-one-row" style="width: 4rem">
                      {{ order.sku.sku_formart }}
                    </div>

                    <div
                      style="
                        width: 0.8rem;
                        min-width: 0.8rem;
                        text-align: right;
                      "
                    >
                      x{{ order.count }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-action-sheet
      v-model="show"
      @closed="onClose"
      :actions="actions"
      @select="onSelect"
    />
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    
  </div>
</template>
<style scoped>
/*@import '../../../assets/style/amendVant.css';*/
.cell-t {
  margin-bottom: 0.1rem;
  align-items: flex-start;
}
.add-btn {
  position: fixed;
  width: 100%;
  height: 1.3rem;
  bottom: 0.4rem;
}
.add-b-b {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.goods_item_b {
  width: 100%;
  margin-bottom: 0.1rem;
}
.sale-box {
  width: 6.7rem;
  margin: 0.2rem auto;
  background: #fff;
  min-height: 1rem;
  border-radius: 0.1rem;
  padding: 0.2rem;
}
.main-gray-back {
  min-height: 100%;
  background: #efefef;
}

.show-two-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.show-one-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>

<script>
import Vue from "vue";
import { Tab, Tabs, Toast, PullRefresh, List, ActionSheet } from "vant";
import LoginDialog from "@/components/LoginDialog.vue";

Vue.use(Tab).use(Tabs).use(Toast).use(PullRefresh).use(List).use(ActionSheet);
export default {
  name: "SaleOrderList",
  components: {
    LoginDialog,
  },
  data: function () {
    return {
      show: false,
      check_index: -1,
      actions: [],
      loginShow: false,
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        keywords: "",
        sale_id: 0,
        p: 1,
        step: 10,
      },
      list: [],
    };
  },
  filter: {},
  mounted() {
    document.title = "销售订单";
    let that = this;
    that.params.sale_id = this.$route.query.id;
    that.fetch();
  },
  destroyed() {},
  methods: {
    onSaleGoodsAdd() {
      rbLink({
        name: "SaleGoodsAdd",
        query: {
          id: 0,
          sale_id: this.params.sale_id,
        },
      });
    },
    onItemChange(item, index) {
      // this.check_index = index;
      // this.show = true;
    },
    onSelect(item, index) {
      console.log(item, index);
      let that = this;
      switch (index) {
        
      }
      this.show = false;
    },
    fetch(ref) {
      let that = this;
      this.$api.get(
        "/api/jxc/getSaleUserList",
        this.params,
        (res) => {
          that.loading = false;
          that.params.p += 1;

          if (res.data.currentpage == 1) {
            if (ref) {
              that.$toast("刷新成功");
            }
            that.isLoading = false;
            that.list = res.data.list;
          } else {
            let list = that.list.concat(res.data.list);
            that.list = list;
          }
          if (res.data.list.length == 0) {
            that.finished = true;
          }
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onClose() {
      this.check_index = -1;
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
    },
    // 上拉加载
    onLoad() {
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      this.fetch(1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaleOrderList.vue?54d8eb8b